import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import {
  createCustomTerms,
  readCustomTerm,
  updateCustomTerm,
} from './CustomTerms.service';
import { CustomTermsRequest } from './CustomTerms.types';

export function useCreateCustomTerm() {
  const intl = useIntl().formatMessage;
  const mutation = useMutation(
    (terms: CustomTermsRequest) => createCustomTerms(terms),
    {
      onSuccess() {
        notification.success({
          message: intl({ id: 'companies.update.notification.success' }),
          description: intl({
            id: 'companies.customTerm.created.notification.successDescription',
          }),
        });
      },
      onError(error) {
        notificationError(error);
      },
    },
  );
  return mutation;
}

export function useUpdateCustomTerm() {
  const intl = useIntl().formatMessage;
  const mutation = useMutation(
    (terms: CustomTermsRequest) => updateCustomTerm(terms),
    {
      onSuccess() {
        notification.success({
          message: intl({ id: 'companies.update.notification.success' }),
          description: intl({
            id: 'companies.customTerm.update.notification.successDescription',
          }),
        });
      },
      onError(error) {
        notificationError(error);
      },
    },
  );
  return mutation;
}

export function useCustomTerms() {
  const mutation = useMutation(
    (companyId: number) => readCustomTerm(companyId),
    {
      onError(err) {
        notificationError(err);
      },
    },
  );
  return mutation;
}
